/* global APPCUES_ENV */
export const domain = ({
  app,
  env = APPCUES_ENV,
  facet = 'main',
  region = 'us-west-2',
  baseDomain = 'aws.appcues.net',
}) => `${app}-${facet}.${env}.${region}.${baseDomain}`;
